import { statusChipColors } from "@common/components/statusChip/StatusChip";

// The left side only holds its content, so a filter bar placed straight in it can join the toolbar's row
export const listPageToolbarLeftContentSelector = "[data-list-page-toolbar-left] > &";
export const listPageToolbarContainerName = "listPageToolbar";
// Measured on the toolbar and not the window, as an open pane or AI chat narrows the list without the window changing
export const narrowListPageToolbarQuery = `@container ${listPageToolbarContainerName} (max-width: 600px)`;
export const listPageSearchFieldMinWidth = 180;
export const listPageSearchFieldMaxWidth = 330;
export const listPageToolbarIconButtonSize = 38.5;
// The dot a toolbar button shows when the list differs from its view, the same yellow as a status chip's dot
export const listPageToolbarChangedDot = {
    "& .MuiBadge-badge": { backgroundColor: statusChipColors.yellow.dot },
};
export const listPageToolbarIconButton = {
    "& .MuiButton-root": { minWidth: listPageToolbarIconButtonSize, minHeight: listPageToolbarIconButtonSize, padding: "0 !important" },
};
